<template>
    <div class="user-component" @click="$router.push('/user/' + user.id)" :style="{ background: 'url(' + background + ')' }">
        <div class="user-info">
            <ion-text class="number-views">
                <img class="icon-img-xs" src="@/assets/icon-images/views.png" />
                <span>{{ user.received_views }}</span>
            </ion-text>
            <ion-text class="user-name"
                >{{ user.name }}
                <div v-if="user.is_online" class="tooltip online-status">
                    <span class="tooltiptext">{{ $t('home.online') }}</span>
                </div></ion-text
            >
            <ion-text class="user-age">{{ userAge ? $t('options.' + userAge) : '' }}</ion-text>
            <ion-text class="user-country">{{ userCountry ? $t('options.' + userCountry) : '' }}</ion-text>
        </div>
    </div>
</template>

<script>
import { constants } from '../constants'
export default {
    name: 'UserCard',
    props: ['user'],
    data() {
        return {
            background: ''
        }
    },
    mounted() {
        if (this.user.approved_images && this.user.approved_images.length > 0) {
            const path = `${constants.assetsUri}/${this.user.approved_images[0].path}`
            this.background = path
        } else this.background = require('../assets/imgupload.png')
    },
    computed: {
        userAge() {
            return this.user.options.find(option => option.type === 'age') && this.user.options.find(option => option.type === 'age').value
        },
        userCountry() {
            return (
                this.user.options.find(option => option.type === 'country') &&
                this.user.options.find(option => option.type === 'country').value
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.user-component {
    cursor: pointer;
    position: relative;
    height: 0;
    padding-top: 100%;
    background-size: cover !important;

    .user-info {
        background: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.8));
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    ion-text {
        position: absolute;

        &.user-name {
            bottom: 15%;
            left: 5%;
            width: 90%;
            text-align: center;
            background: #7cc18b;
            border-radius: 20px;
            opacity: 0.8;
            padding: 8px;
        }
        &.user-age {
            color: #ffffff;
            font-size: 65%;
            top: 88%;
            left: 25%;
        }
        &.user-country {
            color: #ffffff;
            font-size: 65%;
            top: 88%;
            left: 55%;
        }
        &.number-views {
            color: #ffffff;
            background: #244a55;
            text-align: center;
            opacity: 0.8;
            border-radius: 20px;
            top: 7%;
            left: 7%;
            font-size: 70%;
            padding: 3px 7px;

            .icon-img-xs {
                margin-right: 5px;
                position: relative;
                top: 2px;
                height: 15px;
                width: 15px;
            }
        }
    }
}

.online-status {
    width: 15px;
    height: 15px;
    border-radius: 100%;
    background-color: #00ec27;
    position: absolute;
    bottom: 30%;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 90px;
    background-color: #244a55;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    top: -5px;
    z-index: 1;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}

@media (min-width: 768px) {
    ion-text {
        position: absolute;

        &.user-name {
            font-size: 25px;
        }
        &.user-age,
        &.user-country,
        &.number-views {
            font-size: 100% !important;
        }
    }
}

@media (min-width: 1200px) {
    .user-name {
        font-size: 90% !important;
    }
}
</style>
